/* eslint-disable one-var */
module.exports = {
  inserted: function (el, binding, vnode) {
    if (binding.arg) {
      el = document.getElementById(binding.arg)
    }
    if (!el) {
      return
    }
    el.event = function (event) {
      let clientHeight = event.target.clientHeight,
        scrollHeight = event.target.scrollHeight,
        scrollTop = event.target.scrollTop;
      let isInBottom = scrollHeight - scrollTop - clientHeight;
      if(clientHeight+Math.floor(scrollTop)===scrollHeight
        || clientHeight+Math.ceil(scrollTop)===scrollHeight
        || [0,-1,1].indexOf(isInBottom) !== -1){
        vnode.context[binding.expression](event)
      }
    }
    el.addEventListener('scroll', el.event)
  },
  unbind: function (el) {
    el.removeEventListener('scroll', el.event)
  }
}



// WEBPACK FOOTER //
// ./src/directives/scroll-load-more/index.js